module.exports = __webpack_public_path__ + "img/xz.24a42a38.jpg";